import { DataGrid, type DataGridProps } from '@shared/components';

import { ExamEventExamineeResultListNoRowOverlay } from '../exam-event-examinee-result-list-no-row-overlay';

import columns from './columns';
import { type ExamEventExamineeResultListRow } from './types';

export interface ExamEventExamineeResultDataGridProps
  extends Pick<DataGridProps, 'onSortModelChange' | 'slotProps' | 'loading'> {
  rows: ExamEventExamineeResultListRow[];
}

export default function ExamEventExamineeResultDataGrid(
  props: Readonly<ExamEventExamineeResultDataGridProps>,
) {
  const { rows, ...restProps } = props;
  return (
    <DataGrid
      disableColumnMenu
      hideFooter={rows.length === 0}
      disableRowSelectionOnClick
      rows={rows}
      slots={{ noRowsOverlay: ExamEventExamineeResultListNoRowOverlay }}
      columns={columns}
      rowHeight={48}
      sortingMode='server'
      sx={(theme) => ({
        '--DataGrid-overlayHeight': '124px',
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-columnHeader': {
          p: theme.spacing(3),
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
      })}
      {...restProps}
    />
  );
}
